import React, {useEffect} from 'react'
import { Col, Row, Icon } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'

const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const Occupation = (props) => {

  const value = [
    {id: 20, text: 'เกษตรกร'},
    {id: 25, text: 'พระภิกษุ / นักบวช'},
    {id: 30, text: 'เจ้าของกิจการ / ธุรกิจส่วนตัว'},
    {id: 40, text: 'พนักงานบริษัท'},
    {id: 50, text: 'แพทย์ / พยาบาล'},
    {id: 60, text: 'กิจการครอบครัว'},
    {id: 70, text: 'ข้าราชการ'},
    {id: 80, text: 'แม่บ้าน / พ่อบ้าน'},
    {id: 90, text: 'นักลงทุน'},
    {id: 110, text: 'นักการเมือง'},
    {id: 120, text: 'เกษียณอายุ'},
    {id: 130, text: 'อาชีพอิสระ'},
    {id: 140, text: 'พนักงานรัฐวิสาหกิจ'},
    {id: 150, text: 'นักเรียน / นักศึกษา'},
    {id: 160, text: 'ครู / อาจารย์'},
    {id: 170, text: 'อื่นๆ'}
  ]

  useEffect(() => window.scrollTo(0,0));

  const handleClick = (id,value) => {
    props.setOccupation(id,value);
    const otherDocumentAddress = [25,70,140,150,160,170];

    if(otherDocumentAddress.includes(id)) {
      props.setDocumentAddress('other');
    } else {
      props.setDocumentAddress(null);
    }

    if(id === 170) {
      props.history.push('/other-occupation')
    } else {
      props.history.goBack()
    }
  }

  return (
    <Layout title={'เลือกอาชีพ'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกอาชีพ</h4>
      <Row>
        {
          value.map(element => {
            if(element.id === 170) {
              return (
                <StyledCol key={element.id}>
                  <Row style={{marginBottom: '-.5rem'}}>
                    <Col span={22}>
                      <Text onClick={() => handleClick(element.id,element.text)}>{element.text}</Text>
                    </Col>
                    <Col span={2}>
                      <Icon style={{marginTop: '.4rem'}} type="right"/>
                    </Col>
                  </Row>
                  <Divider floatRight={true}/>
                </StyledCol>
              )
            } else {
              return (
                <StyledCol key={element.id}>
                  <Text onClick={() => handleClick(element.id,element.text)}>{element.text}</Text>
                  <Divider floatRight={true}/>
                </StyledCol>
              )
            }
          })
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setOccupation: actions.setOccupation,
  setDocumentAddress: actions.setDocumentAddress
}

const OccupationWithConnect = connect(null, mapDispatchToProps)(Occupation)

export default OccupationWithConnect
